import React from 'react';
import { useTheme } from '@components/theme';
import classNames from 'classnames';
import styles from './ChooseDesignerCTA.module.scss';

interface IChooseDesignerCTA {
  text: string;
  chooseDesigner: () => Promise<void>;
}
export default function ChooseDesignerCTA({ text, chooseDesigner }: IChooseDesignerCTA) {
  const theme = useTheme();

  return (
    <button
      type="button"
      className={classNames(
        theme.styles.Button,
        theme.styles.Primary,
        theme.styles.Small,
        styles.CTA
      )}
      onClick={chooseDesigner}
    >
      {text}
    </button>
  );
}
